if (!customElements.get('lp-gallery-dots')) {
  customElements.define('lp-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.viewer = document.getElementById(this.dataset.viewerId);
      this.slider = this.viewer?.querySelector('[id^="Slider-Gallery-"]');
      if (!this.slider) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      };
      this.slider.addEventListener('scroll', this.schedule, { ...options, passive: true });
      this.viewer.addEventListener('slideChanged', this.schedule, options);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-media-target]');
        if (!button || !this.contains(button)) return;
        const slide = this.slides.find((item) => item.id === button.dataset.mediaTarget);
        if (!slide) return;
        this.slider.scrollTo({
          left: slide.offsetLeft - this.slides[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, options);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.slider);
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this.slider, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'id', 'data-media-id'] });
      this.schedule();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    refresh() {
      this.slides = Array.from(this.slider.children).filter((item) => item.matches('[data-media-id]') && item.clientWidth > 0);
      this.hidden = this.slides.length < 2;
      const signature = this.slides.map((item) => item.id).join('|');
      if (signature !== this.signature) {
        this.signature = signature;
        const buttons = this.slides.map((slide, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'lp-gallery-dot';
          button.dataset.mediaTarget = slide.id;
          button.setAttribute('aria-controls', slide.id);
          button.setAttribute('aria-label', `${this.dataset.slideLabel} ${index + 1}`);
          return button;
        });
        this.replaceChildren(...buttons);
      }
      if (!this.slides.length) return;
      const position = this.slider.scrollLeft;
      const maxPosition = this.slider.scrollWidth - this.slider.clientWidth;
      let active = 0;
      if (maxPosition > 0 && position >= maxPosition - 2) {
        active = this.slides.length - 1;
      } else {
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - this.slides[0].offsetLeft - position);
          if (delta < distance) {
            distance = delta;
            active = index;
          }
        });
      }
      Array.from(this.children).forEach((button, index) => {
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }
  });
}
